import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MedicationCard } from "./MedicationCard";
import { DoseHeatmap } from "./DoseHeatmap";

interface DashboardProps {
  onLogout: () => void;
}

export function Dashboard({ onLogout }: DashboardProps) {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto p-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Medicine Tracker!</h1>
          <Button variant="outline" onClick={onLogout}>
            Logout
          </Button>
        </div>

        <div className="space-y-6">
          {/* Main Medication Card */}
          <MedicationCard />

          {/* Additional Info Cards */}
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">

            <Card>
              <CardHeader>
                <CardTitle>Quick Actions</CardTitle>
                <CardDescription>
                  Manage your tracking
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-2">
                <Button
                  className="w-full"
                  variant="secondary"
                  onClick={() => window.location.reload()}
                >
                  Refresh Status
                </Button>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Support</CardTitle>
                <CardDescription>
                  You're doing great!
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  Consistency is key. Keep up the good work with your medication routine!
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Dose History Heatmap */}
          <DoseHeatmap />
        </div>
      </div>
    </div>
  );
}
